import { Injectable } from '@angular/core';

export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

const NavigationItems = [
  {
    id: 'navigation',
    title: 'ADMINISTRACIÓN',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'profiles',
        title: 'Perfiles',
        type: 'collapse',
        icon: 'feather icon-layers',
        children: [
          {
            id: 'newProfile',
            title: 'Nuevo',
            type: 'item',
            url: '/profile/newProfile'
          },
          {
            id: 'listProfile',
            title: 'Lista',
            type: 'item',
            url: '/profile/listProfile'
          },
          {
            id: 'updateProfile',
            title: 'Modificar',
            type: 'item',
            url: '/profile/updateProfile'
          },
        ]
      },
      {
        id: 'users',
        title: 'Usuarios',
        type: 'collapse',
        icon: 'feather icon-users',
        children: [
          {
            id: 'newUser',
            title: 'Nuevo',
            type: 'item',
            url: '/user/newUser'
          },
          {
            id: 'listUser',
            title: 'Lista',
            type: 'item',
            url: '/user/listUser'
          },
          {
            id: 'updateUser',
            title: 'Modificar',
            type: 'item',
            url: '/user/updateUser'
          },
        ]
      },
    ]
  },

];

@Injectable()
export class NavigationItem {
  get(administrator: boolean, user: boolean, profile: boolean) {
    const NavigationItems = [
      {
        id: 'navigation',
        title: 'ADMINISTRACIÓN',
        type: 'group',
        icon: 'icon-navigation',
        hidden: administrator,
        children: [          
          {
            id: 'perfil',
            title: 'Perfiles',
            type: 'collapse',
            icon: 'feather icon-sliders',
            hidden: profile,
            children: [
              {
                id: 'newProfile',
                title: 'Nuevo',
                type: 'item',
                url: '/profile/newProfile'
              },
              {
                id: 'listProfile',
                title: 'Lista',
                type: 'item',
                url: '/profile/listProfile'
              },
            ]
          },
          {
            id: 'user',
            title: 'Usuarios',
            type: 'collapse',
            icon: 'feather icon-user',
            hidden: user,
            children: [
              {
                id: 'newUser',
                title: 'Nuevo',
                type: 'item',
                url: '/user/newUser'
              },
              {
                id: 'listUser',
                title: 'Lista',
                type: 'item',
                url: '/user/listUser'
              },
            ]
          },
         
        ]
      },
    
    ];
    return NavigationItems;
  }

  getonlyList() {
    const NavigationItems = [
      {
        id: 'navigation',
        title: 'ADMINISTRACIÓN',
        type: 'group',
        icon: 'icon-navigation',
        children: [
          {
            id: 'perfil',
            title: 'Perfil',
            type: 'collapse',
            icon: 'feather icon-user-check',
            children: [
              {
                id: 'newProfile',
                title: 'Nuevo',
                type: 'item',
                url: '/profile/newProfile'
              },
              {
                id: 'listProfile',
                title: 'Lista',
                type: 'item',
                url: '/profile/listProfile'
              },
              {
                id: 'updateProfile',
                title: 'Modificar',
                type: 'item',
                url: '/profile/updateProfile'
              }
            ]
          },
          {
            id: 'user',
            title: 'Usuario',
            type: 'collapse',
            icon: 'feather icon-user',
            children: [
              {
                id: 'newUser',
                title: 'Nuevo',
                type: 'item',
                url: '/user/newUser'
              },
              {
                id: 'listUser',
                title: 'Lista',
                type: 'item',
                url: '/user/listUser'
              },
              {
                id: 'updateUser',
                title: 'Modificar',
                type: 'item',
                url: '/user/updateUser'
              }
            ]
          },          
      
        ]
      },
    ];
    return NavigationItems;
  }

}

